import Vuex from 'vuex'

import Config from '../app.config'

export default {

    computed: {

        ...Vuex.mapState([
            'windowWidth',
        ]),

        /**
         * Obtains the active Breakpoint.
         *
         * @return {string} The name of the active breakpoint, 'small', 'mid', 'wide', 'wider' or 'superwide'.
         */
        activeBreakpoint() {
            if (this.windowWidth <= Config.cssBreakpoints.$small)
                return 'small'
            if (this.windowWidth <= Config.cssBreakpoints.$mid)
                return 'mid'
            if (this.windowWidth <= Config.cssBreakpoints.$wide)
                return 'wide'
            if (this.windowWidth <= Config.cssBreakpoints.$wider)
                return 'wider'

            return 'superwide'
        },

        isDesktopViewport() {
            return this.windowWidth > Config.cssBreakpoints.$mid
        },

        isMobileViewport() {
            return this.windowWidth <= Config.cssBreakpoints.$small
        },

        isMidViewportOrLess() {
            return this.windowWidth <= Config.cssBreakpoints.$mid
        },
    },

    watch: {

        /**
         * Watches the window width, calling a method when the breakpoint changes.
         *
         * @param {number} newWidth
         * @param {number} oldWidth
         */
        windowWidth(newWidth, oldWidth) {
            const hasMovedToWide = newWidth <= Config.cssBreakpoints.$wide && oldWidth > Config.cssBreakpoints.$wide || newWidth > Config.cssBreakpoints.$mid && oldWidth <= Config.cssBreakpoints.$mid
            const hasMovedToMid = newWidth <= Config.cssBreakpoints.$mid && oldWidth > Config.cssBreakpoints.$mid || newWidth > Config.cssBreakpoints.$small && oldWidth <= Config.cssBreakpoints.$small
            const hasMovedToSmall = newWidth <= Config.cssBreakpoints.$small && oldWidth > Config.cssBreakpoints.$small
            if (hasMovedToWide || hasMovedToMid || hasMovedToSmall) this.onBreakpointChange(this.activeBreakpoint)
        },
    },

    methods: {

        /**
         * Called when the breakpoint changes. Override this to provide implementation.
         *
         * @param {string} activeBreakpoint The name of the active breakpoint (also see this.activeBreakpoint)
         */
        onBreakpointChange(activeBreakpoint) {
            this.$logger.log(`Breakpoint has changed to ${ activeBreakpoint }`, 'Responsive')
        },
    },
}
